import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { TenderTipTaxService} from '../../../../POS/POSServices/Setup/tender-tip-tax.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss']
})
export class TipsComponent implements OnInit {
  isReadytoUpdatetips:boolean=false;
  merchantdata: UserPOSData ;
  dateTime;
  hidetip1Percentage: boolean = false;
  hidetip2Percentage: boolean = false;
  hidetip3Percentage: boolean = false;
  hidetip4Percentage: boolean = false;
  hideEnableTip1: boolean = false;
  hideEnableTip2: boolean = false;
  hideEnableTip3: boolean = false;
  hideEnableTip4: boolean = false;
  isNewTips: boolean = true;
  isUpdateTips: boolean = false;
  isTip1Percentage:boolean=false;
  isTip2Percentage:boolean=false;
  isTip3Percentage:boolean=false;
  isTip4Percentage:boolean=false;
  rows;
  Tip1Label = new FormControl("", [Validators.required]);
  // Tip1Percentage =new FormControl("", [ Validators.required, Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  Tip1Percentage =new FormControl("", [  Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  Tip2Label = new FormControl("", [Validators.required]);
  Tip2Percentage =new FormControl("", [  Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  Tip3Label = new FormControl("", [Validators.required]);
  Tip3Percentage = new FormControl("", [ Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  Tip4Label = new FormControl("", [Validators.required]);
  Tip4Percentage = new FormControl("", []);
  EnableTip: boolean = false;
  EnableTip1: boolean = false;
  EnableTip2: boolean = false;
  EnableTip3: boolean = false;
  EnableTip4: boolean = false;
id= new FormControl("", [Validators.required]);
ContactPerference  = new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: TenderTipTaxService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
     this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGettipsDetails();
  }
  getGettipsDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetTipsDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.id > 0) {
        this.dateTime=result.dateTime;

        // this.EnableTip=result.enableTip
        // this.EnableTip=result.enableTip
        this.EnableTip=result.enableTip
        this.EnableTip1=result.enableTip1
        if( this.EnableTip1==true)
        {
            this.hidetip1Percentage=true;
        }
       else
         {
           this.hidetip1Percentage=false;
          }
        this.EnableTip2=result.enableTip2
        if( this.EnableTip2==true)
        {
            this.hidetip2Percentage=true;
        }
       else
         {
           this.hidetip2Percentage=false;
          }
        this.EnableTip3=result.enableTip3
        if( this.EnableTip3==true)
        {
            this.hidetip3Percentage=true;
        }
       else
         {
           this.hidetip3Percentage=false;
          }
        this.EnableTip4=result.enableTip4
        if( this.EnableTip4==true)
        {
            this.hidetip4Percentage=true;
        }
       else
         {
           this.hidetip4Percentage=false;
          }
        this.isUpdateTips = true;
        this.isNewTips = false;
        this.rows = result;
      } 
      else {
        this.isUpdateTips = false;
        this.isNewTips = true;
      }
    });

  }


  mychange(event)
  {
   var tip1=this.Tip1Percentage.value;
   tip1="+tip1";
   var tip2=this.Tip2Percentage.value;
   tip2="+tip2";
   var tip3=this.Tip3Percentage.value;
   tip3="+tip3";
   var tip4=this.Tip4Percentage.value;
   tip4="+tip4";
   if(tip1!="")
   {
    if(tip1<="40")
    {
    this.isTip1Percentage=false;
    }
    else
    {
     this.isTip1Percentage=true;
    }
   }
   if(tip2!="")
   {
    if(tip2<="40")
    {
    this.isTip2Percentage=false;
    }
    else{
     this.isTip2Percentage=true;
    }
   }
   if(tip3!="")
   {
    if(tip3<="40")
    {
    this.isTip3Percentage=false;
    }
    else{
     this.isTip3Percentage=true;
    }
   }
   if(tip4!="")
   {
    if(tip4<="40")
    {
    this.isTip4Percentage=false;
    }
    else{
     this.isTip4Percentage=true;
    }
   }
   
  }



  EnableTips()
  {
    this.EnableTip=!this.EnableTip
    
  }
  
  EnableTip11()
  {
    this.EnableTip1=!this.EnableTip1
    if( this.EnableTip1==true)
    {
      this.hideEnableTip1=true;
      this.hidetip1Percentage=true;
    }
    else{
      this.hideEnableTip1=false;
      this.hidetip1Percentage=false;
    }
  }
  EnableTip21()
  {
    this.EnableTip2=!this.EnableTip2
    if( this.EnableTip2==true)
    {
      this.hideEnableTip2=true;
      this.hidetip2Percentage=true;
    }
    else{
      this.hideEnableTip2=false;
      this.hidetip2Percentage=false;
    }
  }
  EnableTip31()
  {
    this.EnableTip3=!this.EnableTip3
    if( this.EnableTip3==true)
    {
      this.hideEnableTip3=true;
      this.hidetip3Percentage=true;
    }
    else{
      this.hideEnableTip3=false;
      this.hidetip3Percentage=false;
    }
    
  } 
  EnableTip41()
  {
    this.EnableTip4=!this.EnableTip4
    if( this.EnableTip4==true)
    {
      this.hideEnableTip4=true;
      this.hidetip4Percentage=true;
    }
    else{
      this.hideEnableTip4=false;
      this.hidetip4Percentage=false;
    }
  }


  savetips() {
   
    let form = {
      PosSubscriptionId:"",
      Tip1Label:"",
      Tip1Percentage:"",
      Tip2Label:"",
      Tip2Percentage:"",
      Tip3Label:"",
      Tip3Percentage:"",
      Tip4Label:"",
      Tip4Percentage:"",
      EnableTip:false,
      EnableTip1:false,
      EnableTip2: false,
      EnableTip3: false,
      EnableTip4: false,
      };

     form.EnableTip = this.EnableTip;
      form.EnableTip1 = this.EnableTip1;
      form.EnableTip2 = this.EnableTip2;
      form.EnableTip3 = this.EnableTip3;
      form.EnableTip4 = this.EnableTip4;
    form.Tip1Label = this.Tip1Label.value;
    form.Tip1Percentage = this.Tip1Percentage.value;
    form.Tip2Label = this.Tip2Label.value;
    form.Tip2Percentage = this.Tip2Percentage.value;
    form.Tip3Label = this.Tip3Label.value;
    form.Tip3Percentage = this.Tip3Percentage.value;
    form.Tip4Label = this.Tip4Label.value;
    form.Tip4Percentage = this.Tip4Percentage.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    // form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddTips(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // this.dialog.open(SuccessPopupComponent, {
        //   data: "Tip Added Successfully !1"
        // });
        localStorage.removeItem('Tipslist');
        swal("Added", "Tip Added Successfull", "success"); 
        this.router.navigate(["/pos/tips/manage"]);
    }
    });
  }


  updatetips()
  {
    let form = {

      id:"",
      PosSubscriptionId:"",
      Tip1Label:"",
      Tip1Percentage:"",
      Tip2Label:"",
      Tip2Percentage:"",
      Tip3Label:"",
      Tip3Percentage:"",
      Tip4Label:"",
      Tip4Percentage:"",
      EnableTip:false,
      EnableTip1:false,
      EnableTip2: false,
      EnableTip3: false,
      EnableTip4: false,
      DateTime:"",
      };
    form.EnableTip = this.EnableTip;
    form.EnableTip1 = this.EnableTip1;
    form.EnableTip2 = this.EnableTip2;
    form.EnableTip3 = this.EnableTip3;
    form.EnableTip4 = this.EnableTip4;
    form.Tip1Label = this.Tip1Label.value;
    form.Tip1Percentage = this.Tip1Percentage.value;
    form.Tip2Label = this.Tip2Label.value;
    form.Tip2Percentage = this.Tip2Percentage.value;
    form.Tip3Label = this.Tip3Label.value;
    form.Tip3Percentage = this.Tip3Percentage.value;
    form.Tip4Label = this.Tip4Label.value;
    form.Tip4Percentage = this.Tip4Percentage.value;
    form.id=this.id.value;
    form.DateTime=this.dateTime;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    // form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
   
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.UpdateTips(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // this.dialog.open(SuccessPopupComponent, {
        //   data: "Tip Updated Successfully !1"
        // });
        localStorage.removeItem('Tipslist');
        swal("Added", "Tip Updated Successfully", "success"); 
        this.router.navigate(["/pos/tips/manage"]);
      }
    });
  }


  Tip1LabelError() {
    return this.Tip1Label.hasError("required") ? "Tip1Label Name is required"
      : this.Tip1Label.hasError("pattern") ? "Tip1Label should be allow only alphabets" : "";
  }
 
  Tip1PercentageError() {
    return this.Tip1Percentage.hasError("required") ? "Tip1Percentage is required"
      : this.Tip1Percentage.hasError("pattern") ? "Tip1Percentage should be allow only numbers" : "";
  }
  Tip2LabelError() {
    return this.Tip2Label.hasError("required") ? "Tip2Label is required"
      : this.Tip2Label.hasError("pattern") ? "Tip2Label should be allow only alphabets" : "";
  }
  Tip2PercentageError() {
    return this.Tip2Percentage.hasError("required") ? "Tip2Percentage is required"
      : this.Tip2Percentage.hasError("pattern") ? "Tip2Percentage should be allow only numbers" : "";
  }
  Tip3LabelError() {
    return this.Tip3Label.hasError("required") ? "Tip3Label is required"
      : this.Tip3Label.hasError("pattern") ? "Tip3Label should be allow only alphabets" : "";
  }
  Tip3PercentageError() {
    return this.Tip3Percentage.hasError("required") ? "Tip3Percentage is required"
      : this.Tip3Percentage.hasError("pattern") ? "Tip3Percentage should be allow only numbers" : "";
  }
  Tip4LabelError() {
    return this.Tip4Label.hasError("required") ? "Tip4Label is required"
      : this.Tip4Label.hasError("pattern") ? "Tip4Label should be allow only alphabets" : "";
  }
  Tip4PercentageError() {
    return this.Tip4Percentage.hasError("required") ? "Tip4Percentage is required"
      : this.Tip4Percentage.hasError("pattern") ? "First Name should be allow only numbers" : "";
  }
  onKey()
  {
    this.isReadytoUpdatetips = true;
  }
}
